import React from "react";

function Frame11Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.279"
      height="44.508"
      viewBox="0 0 44.279 44.508"
    >
      <g
        id="_1:1-Non_Active"
        data-name="1:1-Non Active"
        transform="translate(1.5 1.5)"
        opacity="0.5"
      >
        <g id="Group_28598" data-name="Group 28598" transform="translate(0 0)">
          <g id="Group_28106" data-name="Group 28106" transform="translate(0)">
            <path
              id="Path_18519"
              data-name="Path 18519"
              d="M0,14.957V0H41.279V14.957"
              transform="translate(41.279 41.508) rotate(180)"
              fill="none"
              stroke="#fff"
              strokeWidth="3"
            />
            <path
              id="Path_18520"
              data-name="Path 18520"
              d="M-22786.066-20117.514v-14.955h41.275v14.955"
              transform="translate(22786.066 20132.469)"
              fill="none"
              stroke="#fff"
              strokeWidth="3"
            />
          </g>
          <path
            id="Path_21910"
            data-name="Path 21910"
            d="M3.467,4.653H5.891v-11.7H3.458L.435-4.946v2.205L3.418-4.8h.049ZM9.993,3.08A1.305,1.305,0,1,0,8.688,1.775,1.3,1.3,0,0,0,9.993,3.08Zm0-5.8A1.3,1.3,0,0,0,11.3-4.022,1.294,1.294,0,0,0,9.993-5.327,1.294,1.294,0,0,0,8.688-4.022,1.3,1.3,0,0,0,9.993-2.717Zm6.056,7.369h2.424v-11.7H16.041l-3.024,2.1v2.205L16-4.8h.049Z"
            transform="translate(11.786 21.806)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default Frame11Icon;
